(() => {
  const SOCIAL_PROOF_SELECTORS = [
    '.spr-badge',
    '.spr-container',
    '.spr-review',
    '.loox-rating',
    '.loox-reviews-default',
    '.jdgm-preview-badge',
    '.jdgm-widget',
    '.product-reviews',
    '[data-product-reviews]',
  ];

  const SOCIAL_PROOF_PATTERN =
    /\b(?:from\s+)?\d[\d,]*(?:\.\d+)?\s+(?:reviews?|ratings?|orders?|sales?|sold)\b/i;

  const normalizeSalePrice = (saleContainer) => {
    if (!(saleContainer instanceof Element) || !saleContainer.isConnected) return;

    const priceRoot = saleContainer.closest('.price');
    const currentPrice = saleContainer.querySelector('.price-item--sale');
    const regularContainer = priceRoot?.querySelector('.price__regular');

    if (!priceRoot || !currentPrice || !regularContainer) return;

    currentPrice.classList.remove('price-item--sale');
    currentPrice.classList.add('price-item--regular');
    regularContainer.replaceChildren(currentPrice);
    saleContainer.remove();

    priceRoot.classList.remove('price--on-sale');
    priceRoot.querySelectorAll('.price__badge-sale').forEach((badge) => badge.remove());
  };

  const cleanRoot = (root = document) => {
    if (!root || !root.querySelectorAll) return;

    root
      .querySelectorAll(
        '.product__info-container s.price-item, .card-wrapper s.price-item, .predictive-search s.price-item'
      )
      .forEach((element) => element.remove());

    root
      .querySelectorAll(
        '.card-wrapper .price__sale, .product__info-container .price__sale, .predictive-search .price__sale'
      )
      .forEach(normalizeSalePrice);

    root
      .querySelectorAll('.badge.price__badge-sale, .badge.price__badge-sold-out')
      .forEach((element) => element.remove());

    root
      .querySelectorAll(SOCIAL_PROOF_SELECTORS.join(','))
      .forEach((element) => element.remove());

    root.querySelectorAll('p, span, div').forEach((element) => {
      if (element.children.length > 0) return;
      const text = element.textContent?.trim();
      if (!text || text.length > 90) return;
      if (SOCIAL_PROOF_PATTERN.test(text)) {
        element.remove();
      }
    });
  };

  const init = () => {
    cleanRoot(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            cleanRoot(node.parentElement || node);
          }
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
